/**
 * Trust marker rows may be parsed `parseEntry` output (flat: `id`, `image`) or
 * raw API shape (`fields.id`, `fields.image`). Support both.
 */
export function trustMarkerEntryId(entry) {
  return entry?.fields?.id ?? entry?.id
}

export function trustMarkerEntryImage(entry) {
  return entry?.fields?.image ?? entry?.image
}

export function trustMarkerEntryAlt(entry) {
  return entry?.fields?.alt ?? entry?.alt ?? ''
}

export function trustMarkerEntryLink(entry) {
  return entry?.fields?.link ?? entry?.link
}

export function trustMarkerEntryLogo(entry) {
  return entry?.fields?.logo ?? entry?.logo
}

export function trustMarkerEntryRating(entry) {
  return entry?.fields?.rating ?? entry?.rating
}

export function trustMarkerEntryTotalReview(entry) {
  return entry?.fields?.totalReview ?? entry?.totalReview
}

function parseTrustMarkerNumber(raw) {
  if (raw == null || raw === '') return NaN
  if (typeof raw === 'number') {
    return Number.isFinite(raw) ? raw : NaN
  }

  const n = Number(String(raw).replace(/,/g, '').trim())

  return Number.isFinite(n) ? n : NaN
}

/** Rating as a finite number (handles string / comma-separated CMS values). */
export function trustMarkerEntryRatingNumber(entry) {
  return parseTrustMarkerNumber(trustMarkerEntryRating(entry))
}

/** Review count as a finite number (handles string / comma-separated CMS values). */
export function trustMarkerEntryTotalReviewNumber(entry) {
  return parseTrustMarkerNumber(trustMarkerEntryTotalReview(entry))
}

export function trustMarkerEntryColor(entry) {
  return entry?.fields?.color ?? entry?.color
}

/** Shape `handleClick` / analytics expect (`id`, `link`). */
export function trustMarkerEntryClickPayload(entry) {
  return {
    id: trustMarkerEntryId(entry),
    link: trustMarkerEntryLink(entry),
  }
}

/** First Trustpilot row in a combination’s `trustMarker` array (flat or nested). */
export function trustPilotEntryFromMarkerList(trustMarkerList) {
  if (!Array.isArray(trustMarkerList)) return undefined

  return trustMarkerList.find((entry) => {
    const id = trustMarkerEntryId(entry)?.toLowerCase()

    return id === 'truspilot' || id === 'trustpilot'
  })
}
